// imove-behavior: 显示页面

export default async function(ctx) {
  ctx.emit('beforePageShow');
}